<template>
  <header id="header">
    <div class="container">
      <div class="float-right">
        <a href="https://trafficinfo.westjr.co.jp/readme.html#delay" class="outline" target="_blank">サービス概要<img src="../../assets/images/delay_icon_gray.png"/></a>
        <span class="spacer"></span><!-- 隙間を追加 -->
        <a href="https://trafficinfo.westjr.co.jp/qanda.html#delay_top" class="outline" target="_blank">Q&A<img src="../../assets/images/delay_icon_gray.png"/></a>
        <span class="spacer"></span><!-- 隙間を追加 -->
        <a href="/pc/guideline/outline" class="outline" target="_blank">利用規約<img src="../../assets/images/delay_icon_gray.png"/></a>      
      </div>
      <div class="title">
        <a href="https://www.westjr.co.jp/" target="_blank"><img id="logo" src="../../assets/images/jr_logo.svg" alt="JR西日本旅客鉄道株式会社" width="71"></a>
        <router-link id="delay" :to="{ name: 'SiteTop' }">遅延証明書</router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'site-header'
}
</script>
<style lang="scss" scoped>
@import '../../css/variables';
a {
  &#delay {
    margin-left: 23px;
    font-weight: 600;
  }
}
#logo {
  background-color: #FFFFFF;
}
header {
  line-height: 67px;
  .spacer {
    margin-right: 10px; /* 隙間の右側に10pxのマージンを追加 */
  }
  .title {
    color: $primary;
  }
  .outline {
    color: $text-color;
    display: inline-block;
    font-weight: 600;
    img {
      width: 12px;
      margin-left: 4px;
      margin-bottom: 2px;
    }
  }
}
#delay {
  text-decoration: none;
  font-size: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/SiteHeader.vue